import { getRelatedSecondaryProducts } from '../getRelatedSecondaryProducts';
import {
  PricingProduct,
  PricingProductType,
} from '../../../store/features/products/types';

export interface SecondaryProductsWithProductType {
  secondaryProducts: PricingProduct[];
  optionalProductType: PricingProductType;
}

export function getSecondaryProductsWithProductType(
  primaryProductId: string,
  isSecondLevelActive: boolean,
  optionalProductTypesWithProducts: PricingProductType[],
  productMultipleIds: string[],
): SecondaryProductsWithProductType[] {
  return optionalProductTypesWithProducts.flatMap((optionalProductType) => {
    const secondaryProducts = getRelatedSecondaryProducts(
      optionalProductType.products,
      isSecondLevelActive && Array.isArray(productMultipleIds)
        ? [primaryProductId, ...productMultipleIds]
        : [primaryProductId],
    );

    if (secondaryProducts.length === 0) {
      return [];
    }

    return {
      secondaryProducts,
      optionalProductType,
    };
  });
}
